import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {DashboardLayoutComponent} from './layouts/dashboard-layout/dashboard-layout.component';
import {LiveMapModule} from './pages/live-map/live-map.module';
import {UnauthorizedComponent} from './pages/public/components/unauthorized/unauthorized.component';
import {RootRoute} from './shared/models/angular-routing';
import { SettingsRoutingModule } from './pages/settings/settings-routing.module';

const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: `${RootRoute.MAIN}` },
  { path: 'live-map', pathMatch: 'full', redirectTo: `${RootRoute.MAIN}` },
  // remove both lines below latest 05/2026 once all client browser bookmarks are updated
  { path: 'dashboard/**', pathMatch: 'full', redirectTo: `${RootRoute.MAIN}` },
  { path: 'dashboard', pathMatch: 'full', redirectTo: `${RootRoute.MAIN}` },
  {
    path: '',
    component: DashboardLayoutComponent,
    children: [
      {
        path: RootRoute.MAIN,
        loadChildren: () => LiveMapModule,
      },
    ],
  },
  {
    path: RootRoute.SETTINGS,
    loadChildren: () => SettingsRoutingModule,
  },
  {
    path: 'unauthorized',
    component: UnauthorizedComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(
      routes,
      {
        useHash: false,
        enableTracing: false
      }
      )],
  exports: [RouterModule],
})
export class AppRoutingModule {}
